'use client'

import { OPTIMIZELY_SNIPPET_ID } from "@/constants/optimizely";
import { createLogger } from "@/lib/debug";
import { isBrowser } from "@/lib/utils";
import Script from "next/script";

const logger = createLogger('optimizely');

export const onOptimizelyLoad = () => {
  if (isBrowser()) {
    window.optimizely.push({
      type: 'addListener',
      filter: {
        type: 'lifecycle',
        name: 'initialized',
      },
      handler: () => {
        logger.info('Optimizely initialized');
      },
    });
    window.optimizely.push({
      type: 'addListener',
      filter: {
        type: 'lifecycle',
        name: 'pageActivated',
      },
      handler: (event) => {
        logger.success(`Page '${event.data.page.name ?? event.data.page.apiName}' activated`);
      },
    });

    window.optimizely.push({
      type: 'addListener',
      filter: {
        type: 'lifecycle',
        name: 'pageDeactivated',
      },
      handler: (event) => {
        logger.info(`Page '${event.data.page.name ?? event.data.page.apiName}' deactivated`);
      },
    });

    window.optimizely.push({
      type: 'addListener',
      filter: {
        type: 'analytics',
        name: 'trackEvent',
      },
      handler: (event) => {
        logger.success(`Event '${event.data.name ?? event.data.apiName}' was tracked`);
      },
    });
  }
}

export const OptimizelyScript = (
  <Script
    id={`optimizely-snippet-${OPTIMIZELY_SNIPPET_ID}`}
    src={`https://cdn.optimizely.com/js/${OPTIMIZELY_SNIPPET_ID}.js`}
    strategy="beforeInteractive"
    onReady={onOptimizelyLoad}
  />
);
